import { motion } from "framer-motion";
import { CalendarCheck, ClipboardCheck, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE, TEL } from "./data";

const ease = [0.16, 1, 0.3, 1];

export const PageHero = ({ eyebrow, title, accent, intro, crumbs }) => (
  <section data-testid="page-hero" className="relative overflow-hidden bg-[#0D0D0B] pb-20 pt-32 sm:pt-36">
    <div className="pointer-events-none absolute -left-40 top-20 h-[480px] w-[480px] rounded-full bg-[#FFB000]/10 blur-[120px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
      <nav aria-label="Breadcrumb" className="mb-6 text-sm font-semibold text-[#bdb9af]">
        <Link to="/" className="hover:text-[#FFB000]">Home</Link>
        {crumbs.map((c) => <span key={c}> / <span className="text-[#F2EEE6]">{c}</span></span>)}
      </nav>
      <p className="mb-5 text-xs font-bold uppercase tracking-[0.28em] text-[#FFB000]">{eyebrow}</p>
      <h1 data-testid="page-hero-title" className="font-display max-w-5xl text-6xl uppercase leading-[0.88] text-[#F2EEE6] sm:text-8xl lg:text-9xl">
        <span className="block overflow-hidden pb-[0.04em]"><motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 1, ease }}>{title}</motion.span></span>
        <span className="block overflow-hidden pb-[0.04em]"><motion.span className="block text-[#FFB000]" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 1, delay: 0.1, ease }}>{accent}</motion.span></span>
      </h1>
      <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4, duration: 0.8, ease }} className="mt-8 max-w-2xl text-lg text-[#d6d2c8] sm:text-xl">{intro}</motion.p>
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55, duration: 0.8, ease }} className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
        <a data-testid="page-hero-call-button" href={TEL} className="cta-glow flex items-center justify-center gap-3 rounded-full bg-[#FFB000] px-7 py-5 text-lg font-black uppercase text-[#0D0D0B] transition-transform active:scale-95">
          <Phone className="h-5 w-5" strokeWidth={2.75} /> Call {PHONE}
        </a>
        <div className="flex flex-wrap gap-3 text-sm font-bold text-[#F2EEE6]">
          <span className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2"><ClipboardCheck className="h-4 w-4 text-[#FFB000]" />Free Onsite Quote</span>
          <span className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2"><CalendarCheck className="h-4 w-4 text-[#FFB000]" />Same Day Pickup</span>
        </div>
      </motion.div>
    </div>
  </section>
);
